import { MyConst } from 'data/MyConst'
import React from 'react'
import logoPdf from "assets/logo_pdf.png";

const LoginHeader = () => {
  return (
    <div>
      <div className="card-header header-login header-login-inline">
        <img
          className="logo-login logo-login-inline"
          src={logoPdf}
          alt={MyConst.SYS_SHORT_NAME}
        />
        <span className="login-brand-text">
          <span className="login-brand-title">{MyConst.SYS_SHORT_NAME}</span>
          <span className="login-brand-subtitle">{MyConst.SYS_OWNER_NAME}</span>
        </span>
      </div>
    </div>
  )
}

export default LoginHeader
